export default "__VITE_ASSET__1a698ad3__"